// extracted by mini-css-extract-plugin
module.exports = {"sliderContainer":"RoomsFilter--sliderContainer"};